import React from "react";
import Header from "../components/northern-territory/header";
import ItineraryComponent from "../components/northern-territory/itinerary";
import Layout from "../components/layout";
import SEO from "../components/seo";

const Itinerary = () => (
  <>
    <Layout>
      <SEO title="Northern Territory Itinerary" description="A travel itinerary for a roadtrip from Uluru to Darwin." />
      <Header />
      <ItineraryComponent />
    </Layout>
  </>
);

export default Itinerary;
